import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-87695502"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "custom-footer" };
var _hoisted_2 = { class: "footer-content" };
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("a", {
        href: "/home/informative",
        target: "_blank"
    }, "Informativa privacy"),
    /*#__PURE__*/ _createTextVNode(" - "),
    /*#__PURE__*/ _createElementVNode("a", {
        href: "https://www.micurobene.it/informative/TerminiECondizioni.pdf",
        download: "MiCuroBene_TerminiECondizioni.pdf"
    }, "Termini e Condizioni")
], -1); });
var _hoisted_4 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("a", {
        href: "/UserGuideWeb.pdf",
        target: "_blank"
    }, "Download User Guide")
], -1); });
var _hoisted_5 = { style: { "user-select": "none" } };
var _hoisted_6 = { class: "ml-auto" };
var _hoisted_7 = {
    key: 0,
    class: "p-2 ml-auto pr-4"
};
var _hoisted_8 = {
    key: 1,
    class: "p-5 ml-auto pr-4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
    var _component_font_awesome_layers = _resolveComponent("font-awesome-layers");
    return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("p", _hoisted_5, "Copyright ESH-r ©" + _toDisplayString(new Date().getFullYear()), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
            ($setup.currentGuide)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = function ($event) { return ($setup.downloadGuide($setup.currentGuide.path, $setup.currentGuide.name)); })
                    }, [
                        _createVNode(_component_font_awesome_layers, { class: "fa-2xl q-mark" }, {
                            default: _withCtx(function () { return [
                                _createVNode(_component_font_awesome_icon, { icon: 'fa-solid fa-circle-question' })
                            ]; }),
                            _: 1
                        })
                    ])
                ]))
                : _createCommentVNode("", true),
            ($setup.route.path == '/Registro/Paypal')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                : _createCommentVNode("", true)
        ])
    ]));
}
